import React, { useContext } from "react";
import GithubContext from "../../context/github/githubContext";
import UserResultCard from "./UserResultCard";
import Pagination from "../ui/Pagination";
import ResultsToolbar from "./ResultsToolbar";

const SkeletonGrid = () => (
  <div className="gf-results__grid">
    {[1, 2, 3, 4, 5, 6].map((k) => (
      <div key={k} className="gf-skeleton gf-skeleton--card" />
    ))}
  </div>
);

const ResultsSection = ({ keyword, onPageChange, sortValue, onSortChange }) => {
  const {
    users,
    searchLoading,
    searchMeta,
    insightLogin,
    setInsightLogin,
  } = useContext(GithubContext);

  const perPage = searchMeta?.perPage || 12;
  const page = searchMeta?.page || 1;
  const total = searchMeta?.total ?? 0;

  if (searchLoading && (!users || users.length === 0)) {
    return (
      <section className="gf-results" aria-labelledby="results-heading">
        <h2 id="results-heading" className="gf-section-title">
          Developers
        </h2>
        <SkeletonGrid />
      </section>
    );
  }

  if (!users || users.length === 0) {
    return null;
  }

  return (
    <section className="gf-results" aria-labelledby="results-heading">
      <h2 id="results-heading" className="gf-section-title">
        Developers
      </h2>
      <ResultsToolbar
        mode="developers"
        keyword={keyword}
        total={total}
        page={page}
        perPage={perPage}
        sortValue={sortValue}
        onSortChange={onSortChange}
      />
      <div className="gf-results__grid">
        {users.map((u) => (
          <UserResultCard
            key={u.id}
            user={u}
            insightLogin={insightLogin}
            onSelectInsight={setInsightLogin}
          />
        ))}
      </div>
      <Pagination
        page={page}
        total={total}
        perPage={perPage}
        onPageChange={(p) => onPageChange(p)}
        disabled={searchLoading}
        aria-label="Developer results pagination"
      />
      {searchLoading && users.length > 0 && (
        <p className="gf-muted gf-results__loading">Updating…</p>
      )}
    </section>
  );
};

export default ResultsSection;
